__turbopack_context__.v({
  "placeholder": "SearchBar-module-scss-module__Wg4Yoq__placeholder",
  "search": "SearchBar-module-scss-module__Wg4Yoq__search",
  "shortcut": "SearchBar-module-scss-module__Wg4Yoq__shortcut",
});
